import { useState } from "react";
import { appConfig } from "../../config/appConfig";

interface RagConfigToggleProps {
  className?: string;
}

/* This component is temporarily disabled
export function RagConfigToggle({ className = "" }: RagConfigToggleProps) {
  const [isStreaming, setIsStreaming] = useState(appConfig.rag.useStreaming);

  const toggleStreaming = () => {
    const newValue = !isStreaming;
    setIsStreaming(newValue);
    appConfig.rag.useStreaming = newValue;
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <label className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            checked={isStreaming}
            onChange={toggleStreaming}
          />
          <div
            className={`w-10 h-5 rounded-full transition-colors ${
              isStreaming ? "bg-brand-primary" : "bg-brand-border-strong"
            }`}
          />
          <div
            className={`absolute left-0.5 top-0.5 w-4 h-4 rounded-full transition-transform bg-brand-bg ${
              isStreaming ? "translate-x-5" : ""
            }`}
          />
        </div>
        <span className="ml-2 text-sm text-white/80">
          {isStreaming ? "Streaming mode" : "Standard mode"}
        </span>
      </label>
      <div className="relative group">
        <button className="w-4 h-4 rounded-full bg-white/20 text-white/80 text-xs flex items-center justify-center">
          ?
        </button>
        <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 w-64 p-2 bg-black/80 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          <p className="mb-1">
            <strong>Streaming mode:</strong> Shows response as it's being
            generated, word by word.
          </p>
          <p>
            <strong>Standard mode:</strong> Shows the full response after it's
            complete.
          </p>
        </div>
      </div>
    </div>
  );
}
*/

// Temporary placeholder for RagConfigToggle that does nothing
export function RagConfigToggle({ className = "" }: RagConfigToggleProps) {
  return null;
}
